module.exports = __webpack_public_path__ + "img/7@2x.e819a3c2.png";